import type { MarketProgram } from '@/features/site/types/marketProgram'
import type { MarketProgramType } from '@/types/marketProgramType'

export function getMarketProgramTypes(
  marketPrograms?: MarketProgram[] | null,
): Map<number | undefined, MarketProgramType | undefined> {
  return new Map(marketPrograms?.map((mp) => [mp.id, mp.type]))
}
